import assetPath from '/app/packages/lebenslauf/components/src/assets/open-sans-semibold.woff';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')